export const Fonts = {
    publicoHeadline: "'cv', 'Publico Headline', 'icons', serif",
    publico: "'cv', 'Publico', 'icons', serif",
    theinhardt: "'cv', Theinhardt, 'icons', sans-serif",
    plex: "'cv', Plex, 'icons', monospace",
}